function replacing(contentUI, nodeId, nodeUI) {
  return {
    ...contentUI,
    [nodeId]: nodeUI,
  }
}

export function bySettingExpanded(contentUI, nodeId) {
  const nodeUI = contentUI[nodeId] || {}
  if (nodeUI.expanded) {
    return contentUI
  }
  return replacing(contentUI, nodeId, {
    ...nodeUI,
    expanded: true,
  })
}

export function byTogglingExpanded(contentUI, nodeId) {
  const nodeUI = contentUI[nodeId] || {}
  return replacing(contentUI, nodeId, {
    ...nodeUI,
    expanded: !(nodeUI.expanded ?? false),
  })
}
